import { SvgIconComponent } from '@mui/icons-material';
import { z } from 'zod';
import {
  communicationPreferencesSchema,
  employeeTargetingSchema,
  fuelAndConvenienceProfileSchema,
} from './validation';

export type AcquisitionChannelProps = {
  value: string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
};

export enum ACQUISITION_CHANNEL_VALUE {
  Pump = 'PUMP',
  POS = 'POS',
  IOS = 'IOS',
  Android = 'ANDROID',
  Web = 'WEB',
  Sms = 'SMS',
  Imported = 'IMPORTED',
}

export type AcquisitionChannelItem = {
  label: string;
  value: ACQUISITION_CHANNEL_VALUE;
  icon: SvgIconComponent;
};

export type EmployeeTargetingValues = z.infer<typeof employeeTargetingSchema>;

export type FuelAndConvenienceProfileValues = z.infer<typeof fuelAndConvenienceProfileSchema>;

export type CommunicationPreferencesValues = z.infer<typeof communicationPreferencesSchema>;
